module.exports = __webpack_public_path__ + "static/media/yoga.342a890f.svg";